import { CheckToken } from '../actions/auth';
import { GetUser } from '../actions/user';

export default (store) => {
    store.dispatch(CheckToken());
    store.dispatch(GetUser());
};
